import { ReactNode } from 'react';

/** Down chevron used by the filter pills and the collapse button. */
export function ChevronIcon({ width = 11, height = 7 }: { width?: number; height?: number }) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 8' fill='none' aria-hidden='true'>
      <path d='M1 1.5l5 5 5-5' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

interface FilterPillProps {
  label: string;
  /** Orange "a filter is applied" look. */
  active?: boolean;
  open: boolean;
  onToggle: () => void;
  dataTest?: string;
  /** The popover (rendered inside the positioning host, next to the pill) while open. */
  children?: ReactNode;
}

/** A filter pill with a chevron that opens a popover under it — the one look shared by every filter picker. */
export default function FilterPill({ label, active = false, open, onToggle, dataTest, children }: FilterPillProps) {
  return (
    <span className='pp-popover-host'>
      <button
        type='button'
        className={`sessions-preview-smart-pill sessions-preview-smart-pill--select${active ? ' sessions-preview-smart-pill--active' : ''}`}
        onClick={onToggle}
        aria-expanded={open}
        data-test={dataTest}
      >
        <span>{label}</span>
        <ChevronIcon />
      </button>
      {open && children}
    </span>
  );
}
